import { useExitIntent } from "use-exit-intent"
import { useCallback } from "react"
import {
    useECommerceMachine,
    useNotificationMachine,
    useSwitchFlowMachine,
} from "../../../../_common/machines/machines-context"
import { useOnCloseWebQuoteModal } from "../../../web-quote/WebQuoteModal/use-on-close-web-quote-modal"
import useModal from "../../../../../components/ModalProvider/useModal"
import { checkIfLocalStorageIsSupportedByBrowser } from "../../../../_common/local-storage"
import { WebQuoteExitIntent } from "../../web-quote-exit-intent"

export const useEcommerceWebQuoteExitIntent = (isEnabled: boolean): WebQuoteExitIntent => {
    const [state] = useECommerceMachine()
    const [, sendSF] = useSwitchFlowMachine()
    const [stateNF] = useNotificationMachine()
    const { openModal } = useModal()

    const onCloseTracked = useOnCloseWebQuoteModal(() => {
        sendSF({ type: "SELECT_BOOKING_FLOW" })
    })

    const { registerHandler } = useExitIntent({
        desktop: {
            triggerOnMouseLeave: true,
            delayInSecondsToTrigger: 1,
        },
        mobile: {
            triggerOnIdle: true,
            delayInSecondsToTrigger: 5,
        },
    })

    const getAlreadyCatchedCruiseCodes = () => localStorage.getItem(webQuoteExitIntentCruiseCodes)?.split(",") ?? []

    const openExitIntentModal = useCallback(() => {
        const alreadyCatchedCruiseCodes = getAlreadyCatchedCruiseCodes()
        if (
            !alreadyCatchedCruiseCodes.some((value) => value == state.context.cruiseCode) &&
            stateNF.value === "closed"
        ) {
            alreadyCatchedCruiseCodes.push(state.context.cruiseCode)
            localStorage.setItem(webQuoteExitIntentCruiseCodes, alreadyCatchedCruiseCodes.join(","))

            openModal({
                modalType: "web-quote-exit-intent",
                onClose: onCloseTracked,
            })
        }
    }, [onCloseTracked, openModal, state.context.activeStep, state.context.cruiseCode, stateNF.value])

    if (!checkIfLocalStorageIsSupportedByBrowser()) return { openExitIntentModal: () => {}, canTrigger: false }

    const canTrigger = !getAlreadyCatchedCruiseCodes().some((value) => value == state.context.cruiseCode) && isEnabled

    if (canTrigger)
        registerHandler({
            id: "openModal",
            handler: openExitIntentModal,
        })

    return {
        openExitIntentModal,
        canTrigger: canTrigger,
    }
}

const webQuoteExitIntentCruiseCodes = "web-quote-exit-intent-cruise-codes"
